import * as Scrivito from "scrivito";
import blogObjIcon from "assets/images/blog_obj.svg";
import InfoPopupWidget from "widgets/InfoPopupWidget/InfoPopupWidgetClass";
import {
  metadataConfiguratorInitialContent,
  metadataEditingConfigAttributes,
  metadataConfiguratorPropertiesGroups,
  metadataValidations,
} from "objs/_metadataEditingConfig";
import {
  defaultPageEditingConfigAttributes,
  defaultPageInitialContent,
  defaultPageProperties,
  defaultPageValidations,
  defaultPropertiesGroups,
} from "objs/_defaultPageEditingConfig";

Scrivito.provideEditingConfig("ProjectConfigurator", {
  title: "Project Configurator",
  thumbnail: blogObjIcon,
  attributes: {
    ...metadataEditingConfigAttributes,
    ...defaultPageEditingConfigAttributes,
    redirectAfterDelete: {
      title: "Redirection target after Project delete",
      description:
        "Reference where user should be redirected after project delete",
    },
  },
  properties: [...defaultPageProperties, "redirectAfterDelete"],
  propertiesGroups: [
    ...defaultPropertiesGroups,
    ...metadataConfiguratorPropertiesGroups,
  ],
  initialContent: {
    ...metadataConfiguratorInitialContent,
    ...defaultPageInitialContent,

    title: "Project Configurator",
    showConfiguratorNav: true,
    body: new InfoPopupWidget({}),
  },
  validations: [
    ...defaultPageValidations,
    ...metadataValidations,
    [
      "redirectAfterDelete",
      (attr) => {
        if (!attr) {
          return {
            message: "Reference after project delete should be set.",
            severity: "warning",
          };
        }
      },
    ],
  ],
});
